import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { withRouter } from 'next/router';
import { withTheme } from 'styled-components';
import withSizes from 'react-sizes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { handleLogout } from '../../redux/actions';
import { UploadAvatar } from '../../containers';
import { Person, Lock, Ticket, Discount, Brilliant, Logout } from '../../utils';

import {
  ProfileContainer,
  ProfileHeading,
  ProfileNavigation,
  UserContainer,
  ProfileList,
  ProfileItem,
  Icon,
  LogoutButton,
  ProfileContent,
} from './styles';

const ProfileLayout = ({ children, theme, router, handleLogoutClick, heading, isMobile, isInnerPage, userData, loggedIn, onClick }) => (
  <ProfileContainer onClick={onClick}>
    {isMobile && <ProfileHeading>{heading}</ProfileHeading>}
    <ProfileNavigation isInnerPage={isInnerPage}>
      {loggedIn && (
        <UserContainer>
          <UploadAvatar {...userData} isInnerPage={isInnerPage} />
        </UserContainer>
      )}
      <ProfileList>
        <ProfileItem isActive={router.pathname === '/my-account'}>
          <Link href={loggedIn ? '/my-account' : ''}>
            <a>
              <Icon>
                <Person color={router.pathname === '/my-account' ? theme.blue : theme.black} />
              </Icon>
                Account
            </a>
          </Link>
        </ProfileItem>
        <ProfileItem isActive={router.pathname === '/my-password'}>
          <Link href={loggedIn ? '/my-password' : ''}>
            <a>
              <Icon>
                <Lock color={router.pathname === '/my-password' ? theme.blue : theme.black} />
              </Icon>
                Password
            </a>
          </Link>
        </ProfileItem>
        <ProfileItem isActive={router.pathname === '/my-bookings'}>
          <Link href={loggedIn ? '/my-bookings' : ''}>
            <a>
              <Icon>
                <Ticket color={router.pathname === '/my-bookings' ? theme.blue : theme.black} />
              </Icon>
                Bookings
            </a>
          </Link>
        </ProfileItem>
        <ProfileItem isActive={router.pathname === '/my-credits'}>
          <Link href={loggedIn ? '/my-credits' : ''}>
            <a>
              <Icon>
                <Discount color={router.pathname === '/my-credits' ? theme.blue : theme.black} />
              </Icon>
                DayAxe Credits
            </a>
          </Link>
        </ProfileItem>
        <ProfileItem isActive={router.pathname === '/my-membership'}>
          <Link href={loggedIn ? '/my-membership' : ''}>
            <a>
              <Icon>
                <Brilliant color={router.pathname === '/my-membership' ? theme.blue : theme.black} />
              </Icon>
                Membership
            </a>
          </Link>
        </ProfileItem>
      </ProfileList>
      <LogoutButton onClick={handleLogoutClick}>
        <Icon>
          <Logout color={theme.black} />
        </Icon>
          Logout
      </LogoutButton>
    </ProfileNavigation>
    <ProfileContent>
      {!isMobile && <ProfileHeading>{heading}</ProfileHeading>}
      {children}
    </ProfileContent>
  </ProfileContainer>
);

ProfileLayout.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.instanceOf(Object),
  handleLogoutClick: PropTypes.func,
  router: PropTypes.instanceOf(Object),
  userData: PropTypes.instanceOf(Object),
  heading: PropTypes.string,
  isMobile: PropTypes.bool,
  isInnerPage: PropTypes.bool,
  loggedIn: PropTypes.bool,
  onClick: PropTypes.func,
};

const mapStateToProps = state => ({
  userData: state.user.userData,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleLogoutClick: handleLogout,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

export default withTheme(withRouter(connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(ProfileLayout))));
